// 庆祝事件总线: 当前 tab 用 CustomEvent, 跨 tab 用 BroadcastChannel
// 任何页面调用 triggerCelebration(text, kind) 都会在所有打开的 TaskFlow tab 上播放全屏动画

export type CelebrationKind =
  | "confetti"   // 五彩纸屑
  | "fireworks"  // 烟花
  | "starburst"  // 星光绽放
  | "balloon"    // 气球上升
  | "sparkle"    // 闪光粒子
  | "ribbon"     // 彩带
  | "snowfall"   // 飘雪
  | "ripple"     // 涟漪光环
  | "medal"      // 奖牌坠落
  | "rocket"     // 火箭升空
  | "rainbow"    // 彩虹扫过
  | "phoenix";   // 凤凰展翅

export type CelebrationEvent = {
  text: string;
  kind?: CelebrationKind; // 不指定则随机
  title?: string; // 任务标题 (可选)
  taskId?: string;
  source?: "self" | "team";
  durationMs?: number; // 默认 4200
};

const CH_NAME = "taskflow:celebration";
const EVT_NAME = "taskflow:celebration";
const FALLBACK_KINDS: CelebrationKind[] = [
  "confetti", "fireworks", "starburst", "balloon", "sparkle",
  "ribbon", "snowfall", "ripple", "medal", "rocket", "rainbow", "phoenix",
];

let bc: BroadcastChannel | null = null;
function getBC(): BroadcastChannel | null {
  if (typeof window === "undefined") return null;
  if (typeof BroadcastChannel === "undefined") return null;
  if (!bc) bc = new BroadcastChannel(CH_NAME);
  return bc;
}

export function pickRandomKind(): CelebrationKind {
  return FALLBACK_KINDS[Math.floor(Math.random() * FALLBACK_KINDS.length)] ?? "confetti";
}

export function triggerCelebration(payload: CelebrationEvent | string): void {
  const evt: CelebrationEvent = typeof payload === "string" ? { text: payload } : payload;
  const final: CelebrationEvent = { kind: pickRandomKind(), durationMs: 4200, source: "self", ...evt };
  if (typeof window === "undefined") return;
  // 同 tab
  window.dispatchEvent(new CustomEvent(EVT_NAME, { detail: final }));
  // 跨 tab
  try { getBC()?.postMessage(final); } catch {}
}

export function onCelebration(handler: (e: CelebrationEvent) => void): () => void {
  if (typeof window === "undefined") return () => {};
  const wrap = (ev: Event) => handler((ev as CustomEvent<CelebrationEvent>).detail);
  window.addEventListener(EVT_NAME, wrap);
  const channel = getBC();
  const bcWrap = (ev: MessageEvent) => handler(ev.data as CelebrationEvent);
  channel?.addEventListener("message", bcWrap);
  return () => {
    window.removeEventListener(EVT_NAME, wrap);
    channel?.removeEventListener("message", bcWrap);
  };
}